export function prepareApp() {
    return Promise.resolve();
}
